import styled from 'styled-components';

export const ModalContainer = styled.div`
  width: 600px;
  position: fixed;
  background-color: white;
  /* border: solid 1px gray; */
  z-index: 99;
  top: 5vh;
  left: calc(50% - 300px);
  padding: 25px;
  overflow-y: auto;
  box-shadow: 0px 0px 16px rgba(8, 84, 117, 0.08);
  border-radius: 24px;
  @media (max-width: 850px) {
    height: 100%;
    top: 0;
    left: 0;
    width: 100%;
    border-radius: 0;
    padding: 10px;
    /* overflow: scroll; */
  }

  @media (max-height: 750px) {
    height: 100%;
  }
`;
export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const IconCloseWrapper = styled.div`
  cursor: pointer;
`;
export const ModalBody = styled.div``;
export const TotalAmountWrapper = styled.div`
  border: 1px solid ${(props) => props.theme.colors.red4};
  border-radius: 16px;
  padding: 20px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0 10px;
`;

export const DataWrapper = styled.div`
  border: 1px solid ${(props) => props.theme.colors.gray11};
  border-radius: 16px;
  padding: 15px;
  margin: 16px 0 15px;
  @media (max-width: 650px) {
    padding: 15px 10px;
  }
`;
export const DataTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
`;
export const DataReferenceWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px;
  background: ${(props) => props.theme.colors.gray12};
  margin: 5px 0 15px;
  align-items: center;
  @media (max-width: 650px) {
    padding: 15px 10px;
  }

  @media (max-width: 350px) {
    gap: 8px;
  }
`;

export const WarningWrapper = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;